export enum StatusPracyDyplomowej {
  WprowadzanieDanych = 0,
  PrzekazanoDoAkceptacjiDane = 1,
  WprowadzaniePlikow = 2,
  PrzekazanoDoAkceptacjiPliki = 3,
  WBadaniuJsa = 4,
  WystawianieRecenzji = 5,
  PracaGotowaDoObrony = 6,
  PracaPoObronie = 7,
}
